import { NextSeo } from "next-seo"
import Head from "next/head"
import React from "react"

import { AboutUsView } from "@modules/aboutUs/aboutUsView"
const TITLE = "Qeeper | About Us"
const DESC = "Qeeper about us"

const SEO_KEYWORDS = "Qeeper about us"

const AboutUs = () => {
  return (
    <>
      <>
        <Head>
          <meta name="keywords" content={SEO_KEYWORDS} />
        </Head>
        <NextSeo
          title={TITLE}
          description={DESC}
          openGraph={{
            title: TITLE,
            description: DESC,
          }}
        />
      </>
      <>
        <AboutUsView />
      </>
    </>

  )
}

export default AboutUs